<template>
  <div
    class="chart-legend"
    :class="legendClasses"
    v-bind="$attrs"
  >
    <div
      v-for="row in filteredValues"
      :key="row.key"
      v-tooltip="tooltipOptions"
      :class="`chart-legend-line chart-legend-line-${row.key}`"
      :title="buildTooltip(row)"
    >
      <i v-if="showShape" class="shape"></i>
      <span v-html="buildLabel(row, includeValues)"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppChartLegend',
  inheritAttrs: false,
  props: {
    values: {
      type: Array,
      required: true,
    },
    hasTooltips: {
      type: Boolean,
      default: false,
    },
    includeValues: {
      type: Boolean,
      default: true,
    },
    orientation: {
      type: String,
      default: 'horizontal',
      validator: (value) => ['horizontal', 'vertical'].includes(value),
    },
    showShape: {
      type: Boolean,
      default: true,
    },
    buildLabel: {
      type: Function,
      default: (row, includeValues) => includeValues ? `${row.value}% ${row.label}` : row.label,
    },
    filterValues: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    tooltipOptions: Object.freeze({ html: true }),
  }),
  computed: {
    legendClasses() {
      return `chart-legend-${this.orientation}`;
    },
    filteredValues() {
      if (this.filterValues) {
        return this.values.filter((row) => row.value);
      }

      return this.values;
    },
  },
  methods: {
    buildTooltip(row) {
      return this.hasTooltips ? row.tooltip : null;
    }
  },
};
</script>
